export const FLOWLYTICS_PIXEL_WIZARD = 'flowlytics_pixel_wizard'
export const FLOWLYTICS_CONVERSIONS_PAGE = 'flowlytics_conversion_reports_page'
export const FLOWLYTICS_PIXEL_MANAGEMENT_V2 = 'flowlytics_pixel_management_v2'
export const FLOWLYTICS_COMPETITIVE_BENCHMARKING = 'flowlytics_competitive_benchmarking'
export const LOCG_LOGO_FIRST = 'locg_logo_first'
export const LLM_FLOWCODE_GENERATOR = 'llm_flowcode_generator'
export const LLM_LABEL = 'llm_label'
export const LLM_TEST = 'llm_codee_test'
export const F2_UPSELL_UAM_CARD = 'f2_upsell_uam_card'
export const F2_UPSELL_BANNER_ASSETS_PAGE = 'f2_upsell_banner_assets_page'
export const F2_UPSELL_ANALYTICS_PAGE = 'f2_upsell_analytics_page'
export const F2_UPSELL_HOME_PAGE = 'f2_upsell_home_page'
